import { render, staticRenderFns } from "./ImportMappingView.vue?vue&type=template&id=22fba8b8&scoped=true&"
import script from "./ImportMappingView.vue?vue&type=script&lang=js&"
export * from "./ImportMappingView.vue?vue&type=script&lang=js&"
import style0 from "./ImportMappingView.vue?vue&type=style&index=0&id=22fba8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fba8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fba8b8')) {
      api.createRecord('22fba8b8', component.options)
    } else {
      api.reload('22fba8b8', component.options)
    }
    module.hot.accept("./ImportMappingView.vue?vue&type=template&id=22fba8b8&scoped=true&", function () {
      api.rerender('22fba8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ImportMappings/ImportMappingView.vue"
export default component.exports